/**
 * Asynchronously loads the component for ArchivePage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
